/*
    静态全局函数
*/

import Vue from 'vue';
import router from '../router/router';

// 网络请求是否得到正确回应
Vue.prototype.$success200 = function(request){
    return request && request.header && request.header.code == 200
}
// 网络请求是否得到错误回应
Vue.prototype.$error201 = function(request){
    return request && request.header && request.header.code == 201
}
// 保留2位小数函数
Vue.prototype.$toFixed = function(num, allNum){
    let n =  allNum > 0 ? parseFloat(num) / allNum * 100 : 0
    n = n.toFixed(3)
    return parseFloat(n.substring(0,n.toString().length - 1))
},
// 返回上一个路由
Vue.prototype.$back = function(){
    router.go(-1)
}

// 是否是手机号码
Vue.prototype.$isMobile = function(mobile){
    let reg = /^1\d{10}$/;

    if(!mobile){
        return false;
    }
    if (mobile.length === 11 && reg.test(mobile)) {
        return true;
    } else {
        return false;
    }
}

Vue.prototype.$isIntNum = function(val){
    var regPos = /^\d+$/; // 非负整数
    var regNeg = /^\-[1-9][0-9]*$/; // 负整数
    if(regPos.test(val) || regNeg.test(val)){
        return true;
    }else{
        return false;
    }
}

Vue.prototype.$formatSeconds = function(value) {
    var secondTime = parseInt(value);// 秒
    var minuteTime = 0;// 分
    var hourTime = 0;// 小时
    if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if(minuteTime > 60) {
            //获取小时，获取分钟除以60，得到整数小时
            hourTime = parseInt(minuteTime / 60);
            //获取小时后取佘的分，获取分钟除以60取佘的分
            minuteTime = parseInt(minuteTime % 60);
        }
    }
    var result = "" + parseInt(secondTime) + "秒";

    if(minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "分" + result
    }
    if(hourTime > 0) {
        result = "" + parseInt(hourTime) + "小时" + result
    }
    return result
}

Vue.prototype.$formatExcelData = function (data) {
    var arr = []
 
    for(var v of data){
  
        for (var k in v) {
            if (typeof v[k] == 'string') {
                v[k] = '"' + v[k] + '"'
            } else if(typeof v[k] == 'object'){
                // "" 两个引号表示一个单元格，所以要在引号内做换行\r操作
                // console.log(v[k])
                if(v[k] != null){
                    v[k] = '"' + v[k].join('\r') + '"'
                } else {
                    v[k] = '"'+ v[k] + '"'
                }
            } else {
                // console.log(typeof v[k])
            }
        }
        // console.log(v)
        arr.push(v)
    }
    return arr
}

// 格式化日期属性
Date.prototype.Format = function (fmt) { //author: meizz 
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length))
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
    return fmt
}

// 
Vue.prototype.$StrToDate = function(dateStr){
    return new Date(Date.parse(dateStr.replace(/-/g,  "/")))
}


// WEBPACK FOOTER //
// ./src/helper/helper.js